export const environment = {
  production: false,
  apiUrl: 'https://leo-develop.mytrusteddriver.com',
  landingPageUrl: 'https://www.mytrusteddriver.com/',
  usCourtPageUrl: 'https://www.cvb.uscourts.gov',
  name: 'develop',
  honeybadgerApiKey: 'hbp_rQtrUTiIerEwvzC2DEc1F3IwJe6BKR1pZoEt',
  gaId: 'G-NGCN4Y0P5J',
  googleMapId: '9ae0bda389a1b5152137a757',
  googleApiKey: 'AIzaSyD9hLsKs8OnyyAsUrMQ35sPI1Jd7ugY664',
};
